import { GetSystemResponse, UnitDefinition, MetadataDefinition, PartCategory } from '../models/Api';
import { MetadataUnion, GroupUnion, PartUnion } from '../models/GroupUnion';
import { needsConversion } from '../utils/Utils';

function systemGroups(system: GetSystemResponse, unitDefinitions: UnitDefinition[]) {
  let partMetadataArray: MetadataUnion[] = [];
  let groupMetadataArray: MetadataUnion[] = [];

  let unitName: string;
  let unitValue: string;
  let groupUnitName: string;
  let groupUnitValue: string;

  let partName: string;
  let partCategory: PartCategory = {} as PartCategory;
  let partMetadataDefinition: MetadataDefinition;
  let groupMetadataDefinition: MetadataDefinition;

  const Groups: GroupUnion[] = [];
  const groupUnion = {
    instance: {},
    definition: {},
    parts: [] as PartUnion[],
    metadata: [] as MetadataUnion[],
  };

  system.groups?.map((group) => {
    group.metadataInstances?.map((groupMDI) => {
      groupUnitValue = groupMDI.value as string;
      system?.groupMetadataDefinitions?.map((groupMDD) => {
        if (groupMDD.id === groupMDI.definitionId && (groupMDD.displayOnRightPane || groupMDD.displayOnDashboard)) {
          groupUnitName = groupMDD.displayName as string;
          groupMetadataDefinition = groupMDD;
          let groupUnitDefinition = unitDefinitions.find(
            (unitDefinition) =>
              groupMDD.unitGroup !== 'None' &&
              unitDefinition?.unitGroup == groupMDD.unitGroup &&
              unitDefinition?.unitSubgroup == groupMDD.unitSubGroup &&
              unitDefinition?.unit == groupMDI.selectedUnit,
          );
          groupUnitDefinition = groupUnitDefinition ?? {};
          const metadataUnion: MetadataUnion = {
            instance: {
              id: groupMDI.id as number,
              name: groupUnitName,
              value: groupUnitValue,
            },
            definition: groupMetadataDefinition,
            unitDefinition: groupUnitDefinition,
            needsConversion: false,
          };
          metadataUnion.needsConversion = needsConversion(metadataUnion);
          groupMetadataArray.push(metadataUnion);
        }
      });
    });

    let tempPartsArray: PartUnion[] = [];
    system?.parts?.map((part) => {
      partMetadataArray = [];
      if (group.id === part.groupInstanceId) {
        partName = part?.name as string;
        part.metadataInstances?.map((partMDI) => {
          unitValue = partMDI.value as string;
          system?.partMetadataDefinitions?.map((partMDD) => {
            if (partMDD.id === partMDI.definitionId && (partMDD.displayOnRightPane || partMDD.displayOnDashboard)) {
              unitName = partMDD.displayName as string;
              partMetadataDefinition = partMDD;
              let partUnitDefinition = unitDefinitions.find(
                (unit) =>
                  partMDD.unitGroup !== 'None' &&
                  unit?.unitGroup == partMDD.unitGroup &&
                  unit?.unitSubgroup == partMDD.unitSubGroup &&
                  unit?.unit == partMDI.selectedUnit,
              );
              partUnitDefinition = partUnitDefinition ?? {};
              const metadataUnion: MetadataUnion = {
                instance: {
                  id: partMDI.id as number,
                  name: unitName,
                  value: unitValue,
                },
                definition: partMetadataDefinition,
                unitDefinition: partUnitDefinition,
                needsConversion: false,
              };
              metadataUnion.needsConversion = needsConversion(metadataUnion);
              partMetadataArray.push(metadataUnion);
            }
          });
        });
      }

      if (part.groupInstanceId === group.id) {
        const partInstances = { [`${partName}`]: partMetadataArray };
        system.partCategories?.map((category) => {
          if (category.id === part.categoryId) {
            partCategory = category;
          }
        });

        tempPartsArray.push({
          instance: part,
          category: partCategory,
          metadata: partInstances,
        });
        partCategory = {} as PartCategory;
      }
    });

    const tempGroupUnion = { ...groupUnion };
    tempGroupUnion.instance = group;
    tempGroupUnion.metadata = groupMetadataArray;
    tempGroupUnion.parts = tempPartsArray;
    tempPartsArray = [] as PartUnion[];
    system.groupDefinitions?.map((definition) => {
      if (definition.id === group.definitionId) {
        tempGroupUnion.definition = definition;
      }
    });
    partMetadataArray = [];
    groupMetadataArray = [];
    Groups.push(tempGroupUnion);
  });
  return Groups;
}

export default systemGroups;
